<style lang="css">
@import "../assets/js/slick/slick.css";
</style>

<template>
  <div
    class="section o-section__max-w--narrow o-section__max-w o-section--pt c-loading-section"
    v-bind:class="{'c-loading-section--loaded':productLoaded, 'c-product--loaded':swiperLoaded}"
  >
    <div class="container">
      <div class="columns">
        <div class="column c-column--rows">
          <h1 class="c-product__header">{{ ring.name }}</h1>
          <h3 class="c-product__description">"{{ ring.description }}"</h3>
          <span class="c-product__accordion">
            <span class="c-accordion c-accordion--tiny">
              <h2 class="c-accordion__header" v-on:click="toggleAccordion($event)">More detail</h2>
              <div class="c-accordion__content">
                <h4 class="c-product__detail">{{ ring.detail }}</h4>
              </div>
            </span>
          </span>
          <router-link
            to="/shop"
            v-show="swiperLoaded"
            style="bottom:0; left:0; display:inline-table;"
            class="u-desktop-only c-btn c-btn__link c-btn__link--relative v-fade"
          >Back to shop</router-link>
        </div>
        <div class="column is-6">
          <div v-if="!loading" class="c-product__images">
            <div class="js-slider-for c-product__mainImage">
              <span
                class="c-product__mainImages"
                v-bind:style="{ 'background-image': 'url(' + image.url + ')' }"
                v-for="(image, index) in ring.variations[ring.variationIndex].images"
                :key="image.index"
              ></span>
            </div>
            <span class="c-loading-block c-loading-block--up" style="height:500px;"></span>

            <div class="c-product__carouselImages js-slider-nav">
              <span
                class="c-product__carouselImage"
                v-bind:class="{ 'c-product__carouselImage--active': carouselIndex == index }"
                v-on:click="changeSlide(index)"
                v-for="(image, index) in ring.variations[ring.variationIndex].images"
                :key="image.index"
              >
                <img width="80" height="80" :src="image.url" alt="Signet ring - thumbnail" />
              </span>
            </div>
          </div>
        </div>
        <div class="column c-column--rows c-product">
          <span class="c-product--anim c-product--anim1" style="z-index:3">
            <div class="c-field c-field--abnormal">
              <v-select
                v-model="variation"
                label="variation_name"
                value="variation_name"
                :clearable="false"
                :options="ring.variations"
              ></v-select>
            </div>
          </span>
          <span class="c-product--anim c-product--anim2" style="z-index:2">
            <div class="c-field">
              <v-select
                v-model="size"
                label="text"
                value="value"
                :clearable="false"
                :options="sizes"
              ></v-select>
              <a
                href
                style="z-index:1;"
                class="c-btn__link c-btn__link--dropdown"
                v-on:click="openSizeGuide($event)"
              >SIZE GUIDE</a>
            </div>
          </span>

          <div
            style="z-index:1;"
            v-if="!loading"
            class="c-product__price c-product--anim c-product--anim4"
          >
            <span
              class="c-cart__subTotal-currency"
            >{{ring.variations[ring.variationIndex].price[$store.state.currency].currency}}</span>
            <span class="c-product__price">
              <span v-show="$store.state.currency != 'EUR' && $store.state.currency != 'GBP'">$</span>
              <span v-show="$store.state.currency == 'EUR'">€</span>
              <span v-show="$store.state.currency == 'GBP'">£</span>
              {{price}}
            </span>
          </div>

          <span
            style="z-index:1;"
            class="c-product__aside c-product--anim c-product--anim5"
          >{{ ring.name }} is made to order. It may take up to 4 weeks to ship.</span>
          <div style="z-index:1; width:100%;" class="c-product--anim c-product--anim6">
            <a class="c-btn--block" v-on:click="addToCart($event)" href>Add to cart</a>
          </div>
          <router-link
            to="/shop"
            v-show="swiperLoaded"
            style="bottom:0; left:0; position:relative; display:inline-table;"
            class="u-mobile-only c-btn c-btn__link c-btn__link--shop c-btn__link--relative v-fade"
          >Back to shop</router-link>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import * as swiper from "../assets/js/slick/slick.min.js";
// import { Vue } from 'vue/types/vue';

export default {
  props: ["guid"],
  metaInfo: {
    title: "Product",
    meta: [
      {
        name: "description",
        content: "The Artful Dodgers Ltd Ring. Treat yourself! ",
      },
      { property: "og:title", content: "Ring | Artful Dodgers Ltd" },
      { property: "og:site_name", content: "Artful Dodgers" },
      {
        property: "og:description",
        content: "The Artful Dodgers Ltd. Treat yourself!",
      },
      { property: "og:type", content: "product" },
      { property: "og:url", content: "https://artfuldodgers.co.nz/shop" },
      {
        property: "og:image",
        content: "https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png",
      },
    ],
  },
  data: function () {
    return {
      productLoaded: false,
      ringsFromServer: {},
      variation: {},
      size: { text: "P", value: 55.76 },
      ring: {},
      loading: true,
      carouselIndex: 0,
      swiperLoaded: false,
      price: 0,
      sizeGuideOpen: false,
      currency: "NZD",
      selectedVaration: {
        price: {
          NZD: {
            amount: 0,
            currency: "NZD",
            formatted: "0",
          },
        },
      },
      selectedSize: "M",
      sizes: [
        { text: "A", value: 37.54 },
        { text: "A 1/2", value: 38.26 },
        { text: "B", value: 38.86 },
        { text: "B 1/2", value: 39.58 },
        { text: "C", value: 40.15 },
        { text: "C 1/2", value: 40.84 },
        { text: "D", value: 41.5 },
        { text: "D 1/2", value: 42.13 },
        { text: "E", value: 42.76 },
        { text: "E 1/2", value: 43.45 },
        { text: "F", value: 44.14 },
        { text: "F 1/2", value: 44.45 },
        { text: "F 3/5", value: 44.77 },
        { text: "G", value: 45.11 },
        { text: "G 1/4", value: 45.4 },
        { text: "G 1/2", value: 45.74 },
        { text: "H", value: 46.02 },
        { text: "H 1/2", value: 46.68 },
        { text: "I", value: 47.25 },
        { text: "I 1/2", value: 47.97 },
        { text: "J", value: 48.38 },
        { text: "J 1/4", value: 48.79 },
        { text: "J 1/2", value: 49.32 },
        { text: "K", value: 49.64 },
        { text: "K 1/4", value: 49.95 },
        { text: "K 1/2", value: 50.27 },
        { text: "L", value: 50.58 },
        { text: "L 1/4", value: 51.21 },
        { text: "L 1/2", value: 51.55 },
        { text: "M", value: 51.87 },
        { text: "M 1/2", value: 52.5 },
        { text: "N", value: 53.16 },
        { text: "N 1/2", value: 53.82 },
        { text: "O", value: 54.51 },
        { text: "O 1/2", value: 54.82 },
        { text: "P", value: 55.76 },
        { text: "P 1/2", value: 56.45 },
        { text: "Q", value: 57.15 },
        { text: "Q 1/2", value: 57.65 },
        { text: "Q 3/4", value: 58.21 },
        { text: "R", value: 58.47 },
        { text: "R 1/4", value: 58.72 },
        { text: "R 1/2", value: 59.06 },
        { text: "R 3/4", value: 59.34 },
        { text: "S", value: 60.0 },
        { text: "S 1/4", value: 60.38 },
        { text: "S 1/2", value: 60.66 },
        { text: "S 3/4", value: 60.98 },
        { text: "T", value: 61.29 },
        { text: "T 1/4", value: 61.64 },
        { text: "T 1/2", value: 62.33 },
        { text: "U", value: 62.89 },
        { text: "U 1/2", value: 63.46 },
        { text: "V", value: 63.84 },
        { text: "V 1/4", value: 64.21 },
        { text: "V 1/2", value: 64.97 },
        { text: "W", value: 65.22 },
        { text: "W 1/4", value: 65.5 },
        { text: "W 1/2", value: 65.78 },
        { text: "W 3/4", value: 66.22 },
        { text: "X", value: 66.54 },
        { text: "X 1/4", value: 66.73 },
        { text: "X 1/4", value: 66.92 },
        { text: "Y", value: 67.51 },
        { text: "Y 1/2", value: 68.14 },
        { text: "Z", value: 68.77 },
        { text: "Z + 1/2", value: 69.43 },
        { text: "Z + 1", value: 70.15 },
        { text: "Z + 1.5", value: 71.0 },
      ],
    };
  },
  methods: {
    loadPage: function () {
      var self = this;

      setTimeout(function () {
        setTimeout(function () {
          TweenMax.to($(".c-loading__line-text"), 0.2, {
            x: 200,
            opacity: 0,
            ease: Power2.easeIn,
          });
        }, 100);
        $(".c-loading__line").css("transform-origin", "right");
        TweenMax.to($(".c-loading__line"), 0.5, {
          scaleX: 0,
          ease: Power1.easeOut,
        });

        setTimeout(function () {
          self.productLoaded = true;
          var loadingBlock = $(".c-loading-block");
          TweenMax.to(loadingBlock, 0.25, { scaleX: 1, ease: Power2.easeOut });

          setTimeout(function () {
            $(".c-product__mainImages").fadeTo(0, 1);

            TweenMax.to(loadingBlock, 0.35, { scaleY: 0, ease: Power1.easeIn });
            self.swiperLoaded = true;
            TweenMax.fromTo(
              $(".slick-current"),
              1,
              { x: -100 },
              { x: 0, ease: Power3.easeOut }
            );
            $(".c-loading__line").css("transform-origin", "left");
            setTimeout(function () {
              var thumbnails = $(".c-product__carouselImage");
              TweenMax.staggerTo(
                $(".c-product__carouselImage"),
                0.3,
                { x: 0, opacity: 1 },
                0.075
              );

              //footer
              var footerBar = $("#socialBar");
              TweenMax.to(footerBar, 0.1, { opacity: 0, scaleX: 0 });
              setTimeout(function () {
                TweenMax.to(footerBar, 0, { opacity: 1 });
                TweenMax.to(footerBar, 1.3, {
                  scaleX: 1,
                  ease: Power3.easeOut,
                });
              }, 100);

              setTimeout(function () {
                var footerBar = $("#socialBar");
              }, 400);
            }, 300);
          }, 270);
          self.$parent.loadingLine = false;
        }, 500);
      }, 100);
    },
    toggleAccordion(event) {
      $(event.target).toggleClass("c-accordion__header--open");
      $(event.target).next().slideToggle();
    },
    toggleZoom: function (event) {
      $(event.target).toggleClass("c-product__mainImages--zoomed");
      $(".c-product__images").toggleClass("c-product__images--zoomed");
      if ($(event.target).hasClass("c-product__mainImages--zoomed")) {
        event.target.style.backgroundPositionX = -event.offsetX + 70 + "px";
        event.target.style.backgroundPositionY = -event.offsetY + 80 + "px";
      } else {
        event.target.style.backgroundPositionX = 0 + "px";
        event.target.style.backgroundPositionY = 0 + "px";
      }
    },
    changeSlide: function (index) {
      $(".js-slider-for").slick("slickGoTo", index);
    },
    openSizeGuide: function (e) {
      e.preventDefault();
      this.$parent.toggleRingGuide(true);
      this.$emit("toggleMenu", this.menuOpen);
    },
    addToCart: function (e) {
      e.preventDefault();
      var purchasingInfo = {
        id: this.ring.id,
        name: this.ring.name,
        ring: this.ring,
        selectedVariation: this.selectedVaration,
        price: this.price,
        selectedSize: this.size,
      };

      var copy = JSON.parse(JSON.stringify(purchasingInfo));

      this.$store.commit("addToCart", copy);
    },
    getRing: function () {
      var self = this;

      AWS.config.region = "us-west-2"; // Region
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: "us-west-2:4d64ca9e-fd06-4129-9516-2c7b50c73473",
      });

      var s3 = new AWS.S3({ params: { Bucket: "artfuldodgersrings" } });
      var params = {
        Bucket: "artfuldodgersrings",
        Key: "example.JSON",
      };
      s3.getObject(params, function (err, data) {
        if (err) {
          console.log(err, err.stack);
        } else {
          self.ringsFromServer = JSON.parse(data.Body).rings;
          self.ringsFromServer.forEach(function (ring) {
            if (ring.url == self.$route.params.id) {
              ring.variationIndex = 0;

              ring.variations.forEach(function (variation, index) {
                //Here we would look for the local currency. test git changes.
                variation.imageIndex = 0;
                //TODO DIFFERENT URLS FOR DIFFERENT METALS
                if (index == 0) {
                  variation.setPrice =
                    variation.price[self.$store.state.currency];
                  self.price = variation.setPrice.amount / 100;
                }
              });
              self.ring = ring;
              self.$store.commit("updateRing", ring);
              if (document.head.parentElement.classList.contains("no-webp")) {
                self.ring.variations.forEach(function (variation) {
                  variation.images.forEach(function (image) {
                    image.url = image.url.replace("webp", "png");
                  });
                });
              }
            }
            self.loading = false;
          });
        }
      });
    },
  },
  computed: {
    currencyChange() {
      if (this != undefined && this.$store != undefined) {
        return this.$store.state.currency;
      }
    },
  },
  watch: {
    $route(to, from) {
      //really need to make this smoother.
      var self = this;
      self.currency = self.$store.state.currency;
      self.$nextTick(function () {
        $(".c-accordion__content").each(function (i, e) {
          $(e).slideUp();
        });
      });

      self.getRing();
    },
    currencyChange: function (newVal, oldVal) {
      var self = this;
      var current = { count: self.price };
      if (self.ring.variations != undefined) {
        var newPrice =
          self.ring.variations[self.ring.variationIndex].price[
            self.$store.state.currency
          ].amount / 100;

        TweenMax.to(current, 1, {
          count: newPrice,
          onUpdate: function () {
            self.price = Math.ceil(current.count);
          },
          ease: Power3.easeOut,
        });
      }
    },
    variation: function (newVal, oldVal) {
      if (oldVal.guid != undefined) {
        var self = this;
        self.slick[0].slick.refresh();

        TweenMax.staggerTo(
          $(".c-product__carouselImage"),
          0.27,
          { opacity: 0 },
          0.1
        );
        TweenMax.to($(".c-product__mainImages"), 0.2, { opacity: 0 });

        setTimeout(function () {
          self.ring.variationIndex = self.ring.variations.indexOf(newVal);
          TweenMax.staggerFromTo(
            $(".c-product__carouselImage"),
            0.6,
            { opacity: 0, x: 60 },
            { opacity: 1, x: 0 },
            0.15
          );
          TweenMax.to($(".c-product__mainImages"), 0.4, { opacity: 1 });

          //ONE CURRENCY - TODO
          // var ogPrice = self.ring;
          var current = { count: self.price };
          var newPrice =
            self.ring.variations[self.ring.variationIndex].price[
              self.$store.state.currency
            ].amount / 100;

          TweenMax.to(current, 1, {
            count: newPrice,
            onUpdate: function () {
              self.price = Math.ceil(current.count);
            },
            ease: Power3.easeOut,
          });
          self.$forceUpdate();
        }, 300);
      }
    },
    ring: {
      handler(val) {
        var self = this;

        if (val.variationIndex != undefined) {
          self.variation = val.variations[val.variationIndex];
        }
      },
      deep: true,
    },
  },
  created: function () {
    this.currency = this.$store.state.currency;

    this.$nextTick(function () {
      $(".c-accordion__content").each(function (i, e) {
        $(e).slideUp();
      });
    });
    //NEED TO GET VARIATION SETNT THROUGH IF THERE WAS ONE.
    this.ring = this.$store.state.ringChoice;
    // variation.setPrice = variation.price[0];

    var self = this;

    if (this.ring.id == undefined) {
      this.getRing();
    } else {
      self.loading = false;
      this.price =
        this.ring.variations[this.ring.variationIndex].price[
          self.$store.state.currency
        ].amount / 100;
    }

    //TODO FIGURE OUT TIMING
    var checkExist = setInterval(function () {
      if ($(".js-slider-for").length) {
        clearInterval(checkExist);

        self.slick = $(".js-slider-for").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          infinite: true,
          useTransform: false,
          prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous"><span class="o-shop-item__icon o-shop-item__icon--prev"></span></button>',
          nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next"><span class="o-shop-item__icon o-shop-item__icon--next"></span></button>',
          dots: false,
        });
        self.slick.on("beforeChange", function (
          event,
          slick,
          currentSlide,
          nextSlide
        ) {
          self.carouselIndex = nextSlide;
        });

        setTimeout(function () {
          var imageHeight = $(".c-product__mainImage").height();
          $(".c-loading-block").css("height", imageHeight + "px");
        }, 1);

        // $(".c-product__mainImages").each(function(i, el) {
        //   el.addEventListener("mousemove", e => {
        //     if ($(el).hasClass("c-product__mainImages--zoomed")) {
        //       el.style.backgroundPositionX = -e.offsetX + 70 + "px";
        //       el.style.backgroundPositionY = -e.offsetY + 80 + "px";
        //     } else {
        //       el.style.backgroundPositionX = 0 + "px";
        //       el.style.backgroundPositionY = 0 + "px";
        //     }
        //   });
        //   el.addEventListener("mouseleave", e => {
        //     if ($(el).hasClass("c-product__mainImages--zoomed")) {
        //       $(el).removeClass("c-product__mainImages--zoomed");
        //       $(".c-product__images").removeClass("c-product__images--zoomed");
        //       el.style.backgroundPositionX = 0 + "px";
        //       el.style.backgroundPositionY = 0 + "px";
        //     }
        //   });
        // });
        var waitToLoad = setInterval(function () {
          if (self.$parent.initLoad) {
            clearInterval(waitToLoad);
            self.loadPage();
          }
        }, 100); // check every 100ms
      }
    }, 100); // check every 100ms
  },
};
</script>




// WEBPACK FOOTER //
// Product.vue?062c77ac